module.exports = __webpack_public_path__ + "static/media/photoshop.92064248.png";